export const createDraft = `mutation($model : CreateDraftRequest!){
    createDraft(input : $model){
      kmatID,        
      modVer   
     }
  }`;
